var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowLeftLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19625)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7438 22.1012L27.2438 15.0012L28.7562 16.5989L21.272 23.684C21.2094 23.7521 21.2094 23.848 21.272 23.9161L28.7562 31.0012L27.2438 32.5989L19.7438 25.4989C19.7365 25.492 19.7293 25.485 19.7222 25.4779C18.7926 24.5483 18.7926 23.0518 19.7222 22.1222C19.7293 22.1151 19.7365 22.1081 19.7438 22.1012Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.7,
    height: 17.6,
    fill: "white",
    transform: "translate(19 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeftLight);
export default __webpack_public_path__ + "static/media/icon_arrow_left_light.ee020775.svg";
export { ForwardRef as ReactComponent };